import React from 'react';
import { Editor } from '@tiptap/react';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import Box from '@mui/material/Box';

import { Button } from 'containers/Tiptap/components/tiptap-ui-primitive/button';
import { MarkButton } from 'containers/Tiptap/components/tiptap-ui/mark-button';
import CommentButton from 'containers/Tiptap/components/tiptap-ui/comment-button/comment-button';

interface MainToolbarSectionProps {
  editor: Editor;
  onAddComment: () => void;
  onAskAI: () => void;
  isGenerating: boolean;
}

const MainToolbarSection: React.FC<MainToolbarSectionProps> = ({ editor, onAddComment, onAskAI, isGenerating }) => (
  <>
    <MarkButton type="bold" />
    <MarkButton type="italic" />
    <MarkButton type="strike" />
    <MarkButton type="code" />
    <MarkButton type="underline" />
    <CommentButton editor={editor} addComment={onAddComment} />
    <Button type="button" data-style="ghost" role="button" tabIndex={-1} onClick={onAskAI} disabled={isGenerating}>
      <AutoAwesomeIcon />
      <Box component="span" sx={{ fontSize: '14px' }}>
        Ask AI
      </Box>
    </Button>
  </>
);

export default MainToolbarSection;
